import Guid from "_shared/guids/guid";
import Password from "users/auth/credentials/passwords/password";

export default class ResetPasswordConfirmationAPIRequest {
  public password: string;
  public confirmPassword: string;
  public userId: string;
  public token: string;

  public constructor(password: Password, userId: Guid, token: string) {
    this.password = password.value;
    this.confirmPassword = password.value;
    this.userId = userId.value;
    this.token = token;
  }
}
